import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  where,
} from "firebase/firestore";

import { db } from "../config/firebase";

const COLECOES_EMPRESA_ID = [
  "setores",
  "maquinas",
  "submaquinas",
  "preventivas",
  "preventivasExecucoes",
  "ordensServico",
  "atendimentos",
  "atendimentos_sessoes",
  "atendimentos_sessao_itens",
  "atendimentos_preventiva",
  "osMateriais",
  "procedimentos",
  "pedidosMateriais",
  "estoqueInterno",
  "pecas",
  "fornecedores",
  "defeitos",
  "statusOs",
  "prestadores",
  "cooperadores",
  "usuarios",
];

const COLECOES_CLIENTE_ID = [
  "atendimentos",
  "atendimentos_preventiva",
  "atendimentos_sessao_itens",
  "financeiro_ordens_servico",
  "financeiro_preventivas",
  "financeiro_propostas_instalacoes",
  "financeiro_contratos",
];

async function buscarDocsPorCampo({ nomeColecao, campo, valor, grupoId }) {
  const valorRef = String(valor || "").trim();
  if (!valorRef) return [];

  const colRef = collection(db, nomeColecao);

  if (grupoId) {
    try {
      const snapComGrupo = await getDocs(
        query(colRef, where("grupoId", "==", String(grupoId)), where(campo, "==", valorRef))
      );
      return snapComGrupo.docs;
    } catch {
      // fallback sem grupoId para coleções sem índice composto
    }
  }

  const snap = await getDocs(query(colRef, where(campo, "==", valorRef)));
  return snap.docs;
}

export async function excluirClienteComCascata({ grupoId, clienteId }) {
  const id = String(clienteId || "").trim();
  if (!id) throw new Error("clienteId nao informado");

  const refsMap = new Map();

  const addRef = (nomeColecao, docId) => {
    const key = `${nomeColecao}/${docId}`;
    if (refsMap.has(key)) return;
    refsMap.set(key, doc(db, nomeColecao, docId));
  };

  for (const nomeColecao of COLECOES_EMPRESA_ID) {
    const docsEmpresaId = await buscarDocsPorCampo({
      nomeColecao,
      campo: "empresaId",
      valor: id,
      grupoId,
    });
    docsEmpresaId.forEach((d) => addRef(nomeColecao, d.id));

    const docsEmpresaID = await buscarDocsPorCampo({
      nomeColecao,
      campo: "empresaID",
      valor: id,
      grupoId,
    });
    docsEmpresaID.forEach((d) => addRef(nomeColecao, d.id));
  }

  for (const nomeColecao of COLECOES_CLIENTE_ID) {
    if (nomeColecao.startsWith("financeiro_")) continue;

    const docsClienteId = await buscarDocsPorCampo({
      nomeColecao,
      campo: "clienteId",
      valor: id,
      grupoId,
    });
    docsClienteId.forEach((d) => addRef(nomeColecao, d.id));
  }

  for (const ref of refsMap.values()) {
    // eslint-disable-next-line no-await-in-loop
    await deleteDoc(ref);
  }

  await deleteDoc(doc(db, "empresas", id));

  return {
    registrosExcluidos: refsMap.size,
    clienteExcluido: true,
  };
}
